import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI Core
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { useTheme } from "@mui/material";

// Custom Components
import AppPage from "@/ui/AppPage/AppPage";
import { GridContainer, GridItem } from "@/ui/Grid";

function OperationsVectorizingPage() {
  const { t } = useTranslation();
  const theme = useTheme();


  return (
    <AppPage>
      <GridContainer>

        <GridItem xs={12}>
          Test 1
        </GridItem>
        <GridItem xs={12}>
          Test 2
        </GridItem>
      </GridContainer>
    </AppPage>
  );
}

export default OperationsVectorizingPage;
